import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('applicationNameField');

    return {
        APPLICATION_NAME_FIELD_LABEL: t('applicationNameFieldLabel')
    };
};

export default useTranslation;
